import APIEndpoint from "./APIEndpoint";

// Define filter parameters interface
export interface UserFilterParams {
  email?: string;
  role?: string;
  subscriptionStatus?: boolean;
  hasUsedPremiumSubscription?: boolean;
  lastActiveBefore?: string;
  lastActiveAfter?: string;
  createdBefore?: string;
  createdAfter?: string;
  createdInLastDays?: number;
}

export const GetFullListOfUsers = async (
  page?: number,
  pageSize?: number,
  filters?: UserFilterParams
) => {
  const queryParams = new URLSearchParams();

  // Add pagination parameters
  if (page !== undefined) queryParams.append("page", page.toString());
  if (pageSize !== undefined)
    queryParams.append("pageSize", pageSize.toString());

  // Add filter parameters
  if (filters) {
    Object.entries(filters).forEach(([key, value]) => {
      if (value !== undefined && value !== null && value !== "") {
        queryParams.append(key, value.toString());
      }
    });
  }

  const url = `${APIEndpoint}/users${queryParams.toString() ? `?${queryParams.toString()}` : ""}`;

  return fetch(url, {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      authorization: `${localStorage.getItem("token")}`,
    },
  })
    .then(async (response) => {
      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }
      
      const text = await response.text();
      try {
        return JSON.parse(text);
      } catch (jsonError) {
        console.error("Invalid JSON response:", text);
        throw new Error(`Invalid JSON response: ${text.substring(0, 100)}...`);
      }
    })
    .catch((error) => console.error("Error getting users:", error));
};

export const GetImpersonateToken = async (userId: number) => {
  return fetch(`${APIEndpoint}/users/userToken`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      authorization: `${localStorage.getItem("token")}`,
    },
    body: JSON.stringify({ userId }),
  })
    .then((response) => response.json())
    .catch((error) => console.error("Error getting token:", error));
};

export const UpdateUserFeatureFlags = async (userId: number, featureFlags: string[]) => {
  return fetch(`${APIEndpoint}/users/${userId}/featureFlags`, {
    method: "PUT",
    headers: {
      "Content-Type": "application/json",
      authorization: `${localStorage.getItem("token")}`,
    },
    body: JSON.stringify({ featureFlags }),
  }).then(async (response) => {
    const data = await response.json().catch(() => ({}));
    if (!response.ok) {
      throw new Error((data as any)?.message || "Failed to update feature flags");
    }
    return data as { success: boolean; data: { userId: number; featureFlags: string[] } };
  });
};

export const UpdateViewMode = async (viewMode: "simple" | "advanced") => {
  return fetch(`${APIEndpoint}/users/viewMode`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      authorization: `${localStorage.getItem("token")}`,
    },
    body: JSON.stringify({ viewMode }),
  }).then(async (response) => {
    const data = await response.json().catch(() => ({}));
    if (!response.ok) {
      throw new Error((data as any)?.message || "Failed to update view mode");
    }
    return data as { success: boolean; message: string; viewMode: string };
  });
};
